import styled, { css, keyframes } from "styled-components";
import { theme } from "styles/mui-config";

const containerCss = ({ isShown }) => {
  if (isShown) {
    return css`
      opacity: 1;
      pointer-events: visible;
    `;
  }
};

export const Backdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  transition: 0.3s;
  ${containerCss}
`;
///////////////////////////////////
const slideScale = keyframes`
  0%{
    transform:scale(0.3);
    opacity:0;
  }
  100%{
    transform:scale(1);
    opacity:1;
  }
`;

export const ModalContainer = styled.div`
  background-color: white;
  display: flex;
  width: 92%;
  margin: 20px auto;
  border-radius: 10px;
  height: 95%;
  flex-direction: column;
  align-items: center;
  transform: scale(1);
  transition: 0.3s;
  animation: ${(props) =>
    props.isShown
      ? css`
          ${slideScale} 0.5s ease
        `
      : ""};
`;
/////////////////////////////////////////
export const Head = styled.div`
  margin-top: 10px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  height: 8%;
  font-size: 22px;
  font-family: "IRANSans";
  border-bottom: 1px solid gray;
  color: ${theme.palette.primary.main};
`;
////////////////////////////////////////
export const Content = styled.div`
  overflow-y: auto;
  width: 90%;
  & p {
    direction: rtl;
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;
  }
`;
